module.exports = __webpack_public_path__ + "static/media/green-green.63766923.png";